
import { MutationTypes } from "../store/mutation-types";
import { Options, Vue } from "vue-class-component";
import { useStore } from "../store";

@Options({
  props: {
    selectItems: Array,
    title: String,
  },
  data() {
    return {
      arrow: "up",
      checkedTags: [],
    };
  },
  methods: {
    onClick(item: string) {
      const path = this.store.state.selectFilters;
      if (!this.checkedTags.includes(item)) {
        // add tag if it's not already there
        return (
          this.checkedTags.push(item),
          this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
            programId: path.programId,
            guestType: path.guestType,
            tag: this.checkedTags,
          })
        );
      } else {
        return (
          // remove tag if it's already there
          (this.checkedTags = this.checkedTags.filter(
            (tag: string) => tag != item
          )),
          this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
            programId: path.programId,
            guestType: path.guestType,
            tag: this.checkedTags,
          })
        );
      }
    }, // menu toggle
    showMenu() {
      const path = this.store.state.selectWindow;
      if (!path.open) {
        return (
          this.store.commit(MutationTypes.SET_SELECT_WINDOW, {
            open: true,
            title: this.title,
          }),
          (this.arrow = "down")
        );
      } else {
        return this.hideMenu();
      }
    },
    hideMenu() {
      const path = this.store.state.selectWindow;
      if (path.open && path.title === this.title) {
        return (
          this.store.commit(MutationTypes.SET_SELECT_WINDOW, {
            open: false,
            title: this.title,
          }),
          (this.arrow = "up")
        );
      }
    },
    // reset the select values in the state
    clear() {
      const path = this.store.state.selectFilters;
      return (
        (this.checkedTags = []),
        this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
          programId: path.programId,
          guestType: path.guestType,
          tag: this.checkedTags,
        }),
        this.store.commit(MutationTypes.SET_SELECT_WINDOW, {
          open: false,
          title: "",
        }),
        (this.arrow = "up")
      );
    },
  },
})
export default class TagSelect extends Vue {
  store = useStore();
  selectItems!: [string];
  title!: string;
  arrow: string = "up";
}
